import * as RadixToast from '@radix-ui/react-toast';
import { ReactNode } from 'react';

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  return (
    <RadixToast.Provider swipeDirection={'down'}>
      {children}
    </RadixToast.Provider>
  );
};
